// 防抖 debounce: n秒内只要再次触发事件，就重新计时，除非大于n秒 才会真正执行一次函数
// fn 延迟的函数
// time 延迟的时间
// triggleNow 首次是否延迟执行
export const _debounce = function (fn, time, triggleNow) {
  var t = null;
  var debounced = function () {
    var _self = this,
        args = arguments;
    if(t){
      clearTimeout(t);
    }
    if(triggleNow){
      var exec = !t;
      t = setTimeout(function () {
        t = null
      }, time);
      if(exec){
        fn.apply(_self, args);
      }
    }else{
      t = setTimeout(function () {
        fn.apply(_self, args);
      }, time);
    }
  }
  debounced.remove = function () {
    clearTimeout(t);
    t = null;
  }
  return debounced;
}

// 节流 throttle: n秒内只执行一次被触发的事件处理函数
export const _throttle = function (fn, delay) {
  var t = null,
      begin = new Date().getTime();
  return function () {
    var _self = this,
        args = arguments,
        cur = new Date().getTime();

    clearTimeout(t);

    if(cur - begin >= delay){
      fn.apply(_self, args);
      begin = cur;
    }else{
      t = setTimeout(function () {
        fn.apply(_self, args);
      }, delay);
    }
  }
}

// 获取页面滚动条的位置
export const _getScrollOffset = function  () {
  if(window.pageXOffset >= 0){
    return {
      top: window.pageYOffset,
      left: window.pageXOffset
    }
  }else{
    return {
      top: document.body.scrollTop + document.documentElement.scrollTop,
      left: document.body.scrollLeft + document.documentElement.scrollLeft
    }
  }
}

// 获取元素距离body顶部和最左边
export const _getElemDocPosition = function (el) {
  var parent = el.offsetParent,
      offsetLeft = el.offsetLeft,
      offsetTop = el.offsetTop;
  while(parent){
    offsetLeft += parent.offsetLeft;
    offsetTop += parent.offsetTop;
    parent = parent.offsetParent;
  }
  return {
    top: offsetTop,
    left: offsetLeft
  }
}

export const _getStyle = function (elem, prop) {
  if(window.getComputedStyle){
    if(prop){
      return window.getComputedStyle(elem, null)[prop];
    }else{
      return window.getComputedStyle(elem, null);
    }
  }else{
    if(prop){
      return elem.currentStyle[prop];
    }else{
      return elem.currentStyle;
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/utils.js